export class BackupZeroEtlPolicy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "scope",
            "baseName": "scope",
            "type": "BackupZeroEtlPolicyScope",
            "format": ""
        },
        {
            "name": "multiResourceConfiguration",
            "baseName": "multiResourceConfiguration",
            "type": "MultiResourceBackupZeroEtlConfiguration",
            "format": ""
        },
        {
            "name": "singleResourceConfiguration",
            "baseName": "singleResourceConfiguration",
            "type": "SingleResourceBackupZeroEtlConfiguration",
            "format": ""
        },
        {
            "name": "catalogConfiguration",
            "baseName": "catalogConfiguration",
            "type": "BackupZeroEtlCatalogConfiguration",
            "format": ""
        },
        {
            "name": "storageConfiguration",
            "baseName": "storageConfiguration",
            "type": "BackupZeroEtlStorageConfiguration",
            "format": ""
        },
        {
            "name": "accessConfiguration",
            "baseName": "accessConfiguration",
            "type": "BackupZeroEtlAccessConfiguration",
            "format": ""
        },
        {
            "name": "tableFilters",
            "baseName": "tableFilters",
            "type": "BackupZeroEtlFilters",
            "format": ""
        },
        {
            "name": "syncFrequencyMinutes",
            "baseName": "syncFrequencyMinutes",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "attachedResources",
            "baseName": "attachedResources",
            "type": "number",
            "format": ""
        },
        {
            "name": "processing",
            "baseName": "processing",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlPolicy.attributeTypeMap;
    }
    constructor() {
    }
}
